import { isAxiosError } from 'axios';

// Gateway statuses IIS/Apache return when the API app itself is down or restarting.
const UNREACHABLE_STATUSES = [502, 503, 504];

export const MAX_API_RETRIES = 3;

/**
 * True when the request never got a real answer from the API: a network/CORS failure,
 * a timeout, or a gateway error in front of it. These are worth retrying and, once
 * retries are exhausted, showing the "portal unavailable" page for.
 */
export const isApiUnreachableError = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;
  if (!error.response) return true;
  return UNREACHABLE_STATUSES.includes(error.response.status);
};
